import * as React from 'react';

function SvgLogInOutline(props) {
    return (React.createElement("svg", Object.assign({ width: "24", height: "24", fill: "none", viewBox: "0 0 24 24" }, props),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M8.364 7.446V5.173A2.273 2.273 0 0110.636 2.9h9.091A2.272 2.272 0 0122 5.173V18.81a2.272 2.272 0 01-2.273 2.273h-8.636c-1.255 0-2.727-1.018-2.727-2.273v-2.273" }),
        React.createElement("path", { stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: 1.6, d: "M2 11.992h15.454m-3.636 4.545l4.545-4.545-4.545-4.546v9.091z" })));
}

export default SvgLogInOutline;
